<template>
    <div>
        <MainCateSlider
                v-if="catList.length > 0 && selectedCat != null"
                :cateList="catList"
                :selectedCat="selectedCat"
        ></MainCateSlider>
        <!-- @onClickCate="onClickCate($event)" -->
        <SubCateSlide
                v-if="subCatList != null"
                :subCateList="subCatList"
                :selectedSubCat="selectedSubCat"
                :mainCate="selectedCat"
        ></SubCateSlide>
        <!-- @onClickCate="onClickSubCate($event)" -->
        <div class="mt-8">
            <CampaignList
                    ref="campaign-list"
                    v-if="campaignListConfig != null && campaignListFilter != null"
                    :initListConfig="campaignListConfig"
                    :initFilterConfig="campaignListFilter"
            ></CampaignList>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
//component
import MainCateSlider from './component/MainCateSlider.vue';
import SubCateSlide from './component/SubCateSlide.vue';
import CampaignList from '../CampaignListHome/CampaignList.vue';
//service
import BzbsCategory from '@/core/Campaign/service/BzbsCategory.js';
import { CategoryConfigBuilder } from '@/core/Campaign/config/CategoryConfigModel';
import { CampaignListConfigBuilder, CampaignListFilterConfigBuilder } from '@/core/Campaign/config/CampaignConfigModel';

export default {
    mixins: [ModalMixin, LocaleMixin],
    components: {
        MainCateSlider,
        SubCateSlide,
        CampaignList,
    },
    props: {
        apiConfig: { type: String, required: true },
    },
    data: function () {
        return {
            categoryConfig: null,
            catList: [],
            subCatList: null,
            selectedCat: null,
            selectedSubCat: null,

            campaignListConfig: null,
            campaignListFilter: null,
        };
    },
    mounted: async function () {
        this.modal.loadingModal.show();
        await this.initList();
        this.modal.loadingModal.hide();
    },
    methods: {
        initList: async function () {
            this.initialCategory();
            await this.getCategory();

            let catIdParams = this.$route.params.catId;
            if (!Util.isEmptyStr(catIdParams)) {
                let cat = this.catList.find((item) => item.id == catIdParams);
                this.selectedCat = cat != null ? cat : this.catList[0];
            } else {
                this.selectedCat = this.catList[0];
            }

            if (this.selectedCat != null) {
                this.setSubCate();

                if (this.selectedSubCat != null) {
                    this.setCampaignList(this.selectedSubCat.listConfig, this.selectedSubCat.id);
                } else {
                    this.setCampaignList(this.selectedCat.listConfig, this.selectedCat.id);
                }
            }
        },

        setSubCate: function () {
            this.subCatList = null;
            if (this.selectedCat.subcats != null && this.selectedCat.subcats.length > 0) {
                this.subCatList = this.selectedCat.subcats;

                let subCateIdParams = this.$route.params.subCatId;
                if (!Util.isEmptyStr(subCateIdParams)) {
                    let cat = this.subCatList.find((item) => item.id == subCateIdParams);
                    this.selectedSubCat = cat;
                }

                // Util.log('selectedSubCat', this.selectedSubCat);
            }
        },

        initialCategory: function () {
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig(this.apiConfig)
                .setLocale(this.localeCode)
                .create();
            // console.log('cate config', categoryConfig);

            this.categoryConfig = categoryConfig;
        },

        getCategory: function() {
            return new Promise((resolve) => {
                var categoryParam = this.categoryConfig.getParams();
                // console.log('cate params', categoryParam);

                BzbsCategory.apiGetCategory(categoryParam).subscribe({
                    next: (categories) => {
                        this.catList = categories;
                        // Util.log('cate list', categories);
                        resolve();
                    },
                    error: (err) => {
                        resolve();
                        this.errorApi(err);
                    },
                });
            });
        },

        // onClickCate: function (cate) {
        //     this.selectedCat = cate;
        //     this.setSubCate(true);
        // },
        // onClickSubCate: function (cate) {
        //     this.selectedSubCat = cate;
        //     let listConfig = cate.listConfig;
        //     let catId = cate.id
        //     this.setCampaignList(listConfig, catId);
        // },

        //#region campaign list
        setCampaignList: function(listConfigStr, catId) {
            this.campaignListConfig = null;
            this.campaignListFilter = null;

            let listConfig = new CampaignListConfigBuilder()
                .setConfigList(listConfigStr)
                            .setCatId(catId)
                            .setTop(25);

            this.campaignListConfig = listConfig.create();

            let filterConfig = new CampaignListFilterConfigBuilder();
            this.campaignListFilter = filterConfig.create();
        },
        loadMore: function () {
            if (this.$refs['campaign-list'] != null) {
                this.$refs['campaign-list'].loadMore();
            }
        },
        //#endregion campaign list
    },
}
</script>
<style lang="scss" scoped>
</style>
